// Vuetify 2 initialization
import Vue from 'vue'
import Vuetify from "vuetify"

Vue.use(Vuetify);

export default new Vuetify({
    icons: {
        iconfont: 'md', //Material design icons
    },
    theme: {
        options: {
            customProperties: true,
        },
        themes: {
            light: {
                primary: '#526c5c', //green
                secondary: '#1E4EA0', //blue
                tertiary: '#546E7A', //blue-grey
                fourth: '#5E35B1', //purple
                fifth: '#F4511E', //deep orange
                attention: '#FF9800', //orange
                error: '#C92323', //red
                gray: '#dfdfdf'
            }
        }
    },
});
